export enum CategoriaContaReceberEnum {
    HonExito = 1,
    HonSucumbenciais = 2,
    HonContratuais = 3,
    Outros = 4,
}

export const CategoriaContaReceberLabel = new Map<number, string>([
    [CategoriaContaReceberEnum.HonExito, 'Honorários de êxito'],
    [CategoriaContaReceberEnum.HonSucumbenciais, 'Honorários sucumbenciais'],
    [CategoriaContaReceberEnum.HonContratuais, 'Recebimento de honorários contratuais'],
    [CategoriaContaReceberEnum.Outros, 'Outros'],
]);
